import account from './account'
import setting from './setting'
import user from './user'
import warehouse from './warehouse'
import orderRules from './orderRules'
import iframe from './iframe'

export default { account, setting, user, warehouse, orderRules, iframe }
